import React, { useState, useContext, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Fab } from '@material-ui/core';
import { tableIcons } from '../../Utils/TableIcons'
import { PageContext } from '../../Context/PageProvider'
import AddIcon from '@material-ui/icons/Add'
import UserModal from '../../Components/Modals/UserModal'
import DataTable from '../../Utils/DataTable'

function UserList({ t }) {
    const classes = useStyles();
    const context = useContext(PageContext)
    const api = context.api
    const [tableColumns, setTableColumns] = useState([
        { title: t('first_name'), field: 'firstname' },
        { title: t('last_name'), field: 'lastname' },
        { title: t('email'), field: 'username' },
        { title: t('roles'), field: 'roles' }
    ])
    const [users, setUsers] = useState({})
    const [newUser, setNewUser] = useState(null)
    const [editUser, setEditUser] = useState(null)

    const getUsers = async () => {
        try {
            await getRoles()
            const userList = await api.adminService.getUsers()
            userList && setUsers({ data: userList })
        } catch (error) {
            console.log("can't get users: ", error)
        }
    }


    const getRoles = async () => {
        try {
            const roleList = await api.adminService.getRoles()
            const roleColumn = tableColumns.find(column => column.field === 'roles')

            roleColumn.render = rowData => {
                const titles = []
                rowData.roles.map(_role => {
                    const findRole = roleList.find(role => role._id === _role)
                    findRole && titles.push(findRole.title)
                })
                return titles.join(', ')
            }

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getUsers()
    }, [])


    if (users === null) return null
    return (
        <div className={classes.root}>

            <DataTable
                columns={tableColumns}
                data={users.data}
                actions={[
                    {
                        icon: tableIcons.Edit,
                        tooltip: t('edit'),
                        onClick: (event, data) => setEditUser(data)
                    }
                ]}
                editable={{
                    isDeletable: rowData => !rowData.isSuperAdmin && context.user._id !== rowData._id,
                    onRowDelete: (async (user) => {
                        try {
                            await api.adminService.deleteUser(user._id)
                            setUsers(prevState => {
                                const data = [...prevState.data]
                                data.splice(data.indexOf(user), 1)
                                return { ...prevState, data }
                            })

                        } catch (error) {
                            console.log(error)
                        }

                    })
                }}
            />

            <Fab
                aria-label="add"
                color="primary"
                className={classes.addButton}
                onClick={() => setNewUser(true)}>
                <AddIcon />
            </Fab>


            {
                newUser && <UserModal
                    open={true}
                    onClose={async () => {
                        setNewUser(null)
                        await getUsers()
                    }}
                />
            }
            {
                editUser && <UserModal
                    open={true}
                    onClose={async () => {
                        setEditUser(null)
                        await getUsers()
                    }}
                    user={editUser}
                />
            }

        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '100%',
    },
    addButton: {
        position: 'absolute',
        bottom: '50px',
        right: '50px',
        zIndex: '99999',
        '& svg': {
            color: theme.palette.common.white
        }
    }
}));

export default withTranslation()(UserList)